import { Injectable } from '@angular/core';
import { Resolve, Router} from '@angular/router';
import { MetaService } from '@ngx-meta/core';
import { StorageService } from '../_services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from 'localize-router';
import { ApiService } from '../_services/api.service';
import { of } from 'rxjs';

@Injectable()
export class ThankYouResolver implements Resolve<any> {

  constructor(
    private translate: TranslateService,
    private router: Router,
    private storage: StorageService,
    private api: ApiService,
    private meta: MetaService
    ) {
  }

  resolve() {

    this.meta.setTag('robots', 'noindex');

    const jsonIn = {
      language: this.translate.currentLang,
      tipoEvidenza: 'CARRELLO',
      categoria: null
    };

    return of({}); // this.api.getEvidenze(jsonIn);
  }

}
